import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import cn from 'classnames';

import { limitStringLength } from '../../../../../utils';
import RightArrow from '../../../../../assets/RightArrow';
import Styles from './index.module.scss';

const upperCaseTags = ['sms', 'api', 'id', 'sip', 'acl', 'url','ip'];

const capitalise = (item: string) => {
	if (!item.trim()) return item;
	let splitValues = item.split(" ");
	return splitValues.map(el => `${el.slice(0, 1).toUpperCase()}${el.slice(1)}`).join(" ");
}
const BreadCrumbs: React.FC = () => {
	const location = useLocation();
	const pageArr: Array<string> = location.pathname
		.split('/')
		.filter((item) => (!item || item.startsWith(':') ? undefined : item));

	const renderBreadCrumbText = (item: string) => {
		if (pageArr[0] === "flow-builder" && (pageArr.length > 2 && item === pageArr[2])) {
			return item;
		} else {
			if (upperCaseTags.includes(item)) {
				return capitalise(item.replace(/_/g, ' ').toUpperCase());
			}
			else if (
				upperCaseTags.some((substring) => item.includes(substring))
			) {
				upperCaseTags.forEach((substring) => {
					if (item.includes(substring)) {
						item = capitalise(item.replace(substring, substring.toUpperCase()));
					}
				});
				return capitalise(item.replace(/-/g, ' '));
			}
			else {
				if (item.includes('-')) {
					return capitalise(item.replace(/-/g, ' '));
				} else {
					return capitalise(item.replace(/_/g, ' '));
				}
			}
		}
	};
	return (
		<div className={cn('rowK', Styles.container)}>
			{pageArr.map((item, index, arr) => (
				<React.Fragment key={item + index}>
					{index > 0 && (
						<RightArrow
							height={24}
							width={24}
							color="#C3CDD9"
							className={Styles.arrow}
						/>
					)}
					<NavLink
						to={`/${arr.slice(0, index + 1).join('/')}`}
						className={Styles.link}
						activeClassName={Styles.selected}
						exact
					>
						{limitStringLength(renderBreadCrumbText(item), 25)}
					</NavLink>
				</React.Fragment>
			))}
		</div>
	);
};

export default BreadCrumbs;
